export default {
    aggregate: {
        type: Array,
        default: undefined
    },
    autoSync: {
        type: Boolean,
        default: undefined
    },
    batch: {
        type: Boolean,
        default: undefined
    },
    data: {
        type: [Array, String],
        default: undefined
    },
    filter: {
        type: [Array, Object],
        default: undefined
    },
    group: {
        type: [Array, Object],
        default: undefined
    },
    inPlaceSort: {
        type: Boolean,
        default: undefined
    },
    offlineStorage: {
        type: [String, Object],
        default: undefined
    },
    page: {
        type: [String, Number],
        default: undefined
    },
    pageSize: {
        type: [String, Number],
        default: undefined
    },
    schema: {
        type: Object,
        default: undefined
    },
    serverAggregates: {
        type: Boolean,
        default: undefined
    },
    serverFiltering: {
        type: Boolean,
        default: undefined
    },
    serverGrouping: {
        type: Boolean,
        default: undefined
    },
    serverPaging: {
        type: Boolean,
        default: undefined
    },
    serverSorting: {
        type: Boolean,
        default: undefined
    },
    sort: {
        type: [Array, Object],
        default: undefined
    },
    transport: {
        type: Object,
        default: undefined
    },
    type: {
        type: String,
        default: undefined
    },

    // Events
    change: {
        type: Function,
        default: undefined
    }, 
    error: {
        type: Function,
        default: undefined
    }, 
    push: {
        type: Function,
        default: undefined
    }, 
    requestEnd: {
        type: Function,
        default: undefined
    }, 
    requestStart: {
        type: Function,
        default: undefined
    }, 
    sync: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoDataSourceBase/DataSourceProps.js